import { BaseEntity } from 'src/app/tools/models/baseEntity';


export class ProductAnalysisGroup5 extends BaseEntity {

  productAnalysisGroup5Code : string;
  name                      : string;
  rank                      : string;
   
}